module.exports = __webpack_public_path__ + "static/0035-8ac0a8d8089c45fcf6bb9f36445b79a1.png";